module.exports = __webpack_public_path__ + "static/media/icon-mp4.7bd51939.svg";